// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { reaction } from "mobx";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class SeoProductModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get currentProduct() {
    return this.$store.conversionWorldProduct.current;
  }

  get url() {
    if (this.currentProduct) {
      return (
        "https://conversion-world.mercedes-benz.com/de/GLOBAL/partner-produkt/" +
        this.currentProduct.id +
        "/" +
        this.currentProduct.slug
      );
    } else {
      return "";
    }
  }

  get name() {
    if (this.currentProduct) {
      return this.instance["name"] || this.currentProduct.name;
    } else {
      return "";
    }
  }

  get description() {
    return JSON.stringify(this.htmlDescription);
  }

  get htmlDescription() {
    if (this.currentProduct) {
      if (!this.instance["beschreibung"]) {
        if (this.currentProduct.product_advantages.length > 0) {
          let s = "<ul>";

          this.currentProduct.product_advantages.forEach((advantage) => {
            s += "<li>" + advantage + "</li>";
          });
          s += "</ul>";

          return s;
        }

        return "";
      }

      return this.instance["beschreibung"];
    } else {
      return "";
    }
  }

  get brandName() {
    if (this.currentProduct) {
      return this.instance["marke"] || "Mercedes-Benz Transporter";
    } else {
      return "";
    }
  }

  get herstellerName() {
    if (this.currentProduct) {
      return (
        this.instance["hersteller"] || this.currentProduct.bodybuilder.name
      );
    } else {
      return "";
    }
  }

  get model() {
    if (this.currentProduct) {
      return (
        this.instance["model"] ||
        this.currentProduct.technical_data.model_series
      );
    } else {
      return "";
    }
  }
}
